import { h, render, Component } from 'preact';

class BDCPortfolioPageTotalReturnTable extends Component {
  render() {
    return <h1>{this.props.hello}</h1>
  }
}

export default BDCPortfolioPageTotalReturnTable;
